<template>
    <div class="dialog" id="delete-client-dialog" aria-hidden="true">
        <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
        <div
            role="dialog"
            class="dialog-content dialog-content--add"
            aria-labelledby="my-dialog-title"
            aria-describedby="my-dialog-description"
        >
            <button
                data-a11y-dialog-hide
                class="dialog-close"
                aria-label="Close this dialog window"
            >
                <img src="@/assets/icons/dialog-close.svg" width="24" height="24" :alt="$t('delete_client_modal.dialog_close')" />
            </button>

            <div class="add-form__name">{{ $t('delete_client_modal.deleting_client') }}</div>
            <div class="add-form__controls">
                <span>
                    {{ $t('delete_client_modal.deleting_client_confirmation') }}: {{ clientToDelete.firstName + ' ' + clientToDelete.lastName }}?
                </span>
            </div>
            <div class="dialog__buttons">
                <button class="dialog__button"
                        data-a11y-dialog-hide
                        @click.prevent
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                >{{ $t('delete_client_modal.cancel') }}</button>
                <button class="dialog__button dialog__button--alt"
                        type="submit"
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                        @click.prevent="submitDeleteClient"
                >
                    <template v-if="!sendingForm">
                        {{ $t('delete_client_modal.delete') }}
                    </template>
                    <template v-else>
                        {{ $t('delete_client_modal.deleting') }}
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {onMounted, ref, reactive, watch, inject} from "vue";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";
import {useI18n} from "vue-i18n";

export default {
    name: "deleteClientModal",
    setup() {
        const emitter = inject('emitter');
        const sendingForm = ref(false);
        let clientToDelete = ref('');
        const deleteClientModal = ref();
        let alert = inject('alert');
        const {t} = useI18n();

        onMounted(() => {
            deleteClientModal.value = new A11yDialog(document.querySelector("#delete-client-dialog"));
        });

        function showModal(clientData = null) {
            if (clientData) {
                clientToDelete.value = clientData;
            }
            deleteClientModal.value.show();
        }


        const submitDeleteClient = async () => {
            sendingForm.value = true;
            axios.delete(ApiHelper.getDeleteClientUrl(clientToDelete.value.id), {
                headers: authHelper.authHeader()
            }).then(response => {
                sendingForm.value = false;
                emitter.emit('clientDeleted');
                deleteClientModal.value.hide();
                AlertHelper.show(alert, t('delete_client_modal.deleting_client_confirmation'));
            }).catch(error => {
                sendingForm.value = false;
                let errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
            });
        };

        return {
            clientToDelete,
            showModal,
            sendingForm,
            submitDeleteClient
        }

    }

}
</script>

<style scoped lang="scss">
@use '@/css/variables';
.dialog__buttons {
    button {
        &:hover {
            background: #959595;
        }

        &.dialog__button--alt {
            background: map-get(variables.$colors, default-red);

            &:hover {
                background: #e35748;
            }
        }
    }
}
</style>